/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ITumorBoard {
  id?: string;
  name?: string;
  description?: string | null;
  createdById?: string | null;
  createdByType?: keyof typeof AddedByType | null;
  createdDate?: number;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<ITumorBoard> = {
  active: false,
};
